<div class="body">

    <mat-toolbar class="ams-toolbar">

        <mat-icon class="main-icon">security</mat-icon>

        <span>
            Passwort zurücksetzen
        </span>

        <span class="spacer"></span>

        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>

    </mat-toolbar>

    <div class="content" [formGroup]="formGroup">

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Nutzername</mat-label>
            <input formControlName="userName" matInput placeholder="Ihr Nutzername" />
        </mat-form-field>

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">E-Mail Adresse</mat-label>
            <input formControlName="email" matInput placeholder="Ihre E-Mail Adresse" />
        </mat-form-field>

    </div>

    <div class="footer">

        <button mat-raised-button color="primary" (click)="confirm()">
            Passwort zurücksetzen
        </button>

    </div>

</div>
